import {Component, Input} from '@angular/core';

@Component({
  selector: 'rn-availability-count-pill',
  templateUrl: './availability-count-pill.component.html',
  styleUrl: './availability-count-pill.component.scss',
  standalone: false
})
export class AvailabilityCountPillComponent {
  @Input()
  available: number;
  @Input()
  copies: number;
  @Input()
  holds: number;
}
